import { HashRouter, Route, Routes } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import RiderInvoice from "../pages/RiderInvoice/RiderInvoiceList";
import CreateRiderInvoice from "../pages/RiderInvoice/CreateRiderInvoice";
import EditRiderInvoice from "../pages/RiderInvoice/EditRiderInvoice";
import RiderInvoicePreview from "../pages/RiderInvoice/RiderInvoicePreview";
//@ts-ignore
import {
  AccessControl,
  PermissionRequired,
} from "@careinfo/permission-required";
import RiderFileUpload from "../pages/RiderInvoice/RiderFileUpload";
export const queryClient = new QueryClient();

const RiderInvoiceRouter = () => {
  return (
    <QueryClientProvider client={queryClient}>
      <HashRouter>
        <Routes>
          <Route path={"/"} element={<RiderInvoice />} />
          <Route
            path={"/create"}
            element={
              <AccessControl
                children={<CreateRiderInvoice />}
                allowedPermissions={["can_create_rider_invoice"]}
                renderNoAccess={<PermissionRequired />}
              />
            }
          />

          <Route path={"/edit/:id"} element={<EditRiderInvoice />} />
          <Route path={"/documents/:id"} element={<RiderFileUpload />} />
          <Route path={"/preview/:id"} element={<RiderInvoicePreview />} />
        </Routes>
      </HashRouter>
      <ToastContainer autoClose={500} draggablePercent={30} />
    </QueryClientProvider>
  );
};

export default RiderInvoiceRouter;
